import { useRouter } from 'next/router';

import type * as types from './types';

import { useActivePages } from '@/src/hooks/routing/use-active-pages';

/**
 * Matches a current path against a target path using prefix matching.
 * Root path ("/") requires exact match or query params only.
 * All other paths match if current path starts with target path.
 */
export const matchPath = (currentPath: string, targetPath: string): boolean =>
  targetPath === '/'
    ? /^\/([?#]|$)/.test(currentPath)
    : !!new RegExp(`^${targetPath}`).exec(currentPath);

export const useIsNavButtonSelected = (config: types.ISideNavButton): boolean => {
  const { asPath } = useRouter();
  const activePages = useActivePages();

  if (config.isExternal) {
    return false;
  }

  if (config.activePages || config.activePaths) {
    const activeByPage = config.activePages
      ? config.activePages.some(pageId => activePages.map(page => page.id).includes(pageId))
      : false;

    const activeByPath = config.activePaths
      ? config.activePaths.some(path => matchPath(asPath, path))
      : false;

    return activeByPath || activeByPage;
  } else if (config.page) {
    return activePages.some(page => page.id === config.page);
  }

  return matchPath(asPath, config.href);
};
